import { call, put, takeLatest } from "redux-saga/effects";
import { sagaRoot } from "./root";
import { LOGIN, LOG_OUT, SIGN_UP, TOASTER_SHOW } from "../constant";
import { isDealerUser, pickUserType } from "../utils/userTypes";

// login — dealers portal accepts dealer accounts only (type = 1)
export function* loginSaga(payload) {
  // Suppress the generic success toast until we confirm dealer access.
  const response = yield call(sagaRoot, {
    ...payload,
    payload: {
      ...payload.payload,
      hideSuccessToaster: true,
    },
  });
  if (response?.message?.type === "success") {
    const userType = pickUserType(response.data, response.data?.user);
    if (!isDealerUser({ type: userType, ...(response.data || {}) })) {
      // Clear the non-dealer session that LOGIN_SUCCESS just stored.
      yield put({ type: LOG_OUT });
      yield put({
        type: TOASTER_SHOW,
        payload: {
          show: true,
          autoHide: true,
          type: "error",
          heading: "Dealer access only",
          description:
            "This portal is for dealers only. Please log in on the main site if you have a client account.",
        },
      });
      return;
    }
    yield put({
      type: TOASTER_SHOW,
      payload: response.message,
    });
    window.location.reload(true);
    const callBack = payload.payload.callBack;
    if (typeof callBack === "function") {
      callBack(response);
    }
  }
}

export function* signUpSaga(payload) {
  yield call(sagaRoot, payload);
}

export default function* authWatcher() {
  yield takeLatest(LOGIN, loginSaga);
  yield takeLatest(SIGN_UP, signUpSaga);
}
